require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./stoichkov-hablo-del-barcelona-en-champions-la-vamos-a-tener-facil.json") })
        }
      }, "path---stoichkov-hablo-del-barcelona-en-champions-la-vamos-a-tener-facil");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---stoichkov-hablo-del-barcelona-en-champions-la-vamos-a-tener-facil!./.cache/json/stoichkov-hablo-del-barcelona-en-champions-la-vamos-a-tener-facil.json
// module id = 456
// module chunks = 231608221292675